import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
    app_name: "Family Repository",
    tagline: "Family Legacy",
    logo: null,
    festival: "none",
    content_protection: true,
    support: { email: "", phone: "", whatsapp: "", hours: "" },
};

const BrandingContext = createContext({ ...DEFAULTS, refresh: () => {} });

/**
 * BrandingProvider — fetches the active brand identity (app name, tagline,
 * logo) from /api/branding once on mount. Used app-wide so the admin can
 * rebrand without re-deploying.
 */
export function BrandingProvider({ children }) {
    const [branding, setBranding] = useState(DEFAULTS);

    const refresh = useCallback(() => {
        api.get("/branding")
            .then(({ data }) => {
                setBranding({
                    app_name: data?.app_name || DEFAULTS.app_name,
                    tagline: data?.tagline || DEFAULTS.tagline,
                    logo: data?.logo || null,
                    festival: data?.festival || "none",
                    content_protection: data?.content_protection !== false,
                    support: { ...DEFAULTS.support, ...(data?.support || {}) },
                });
                // Keep the browser tab title in sync.
                if (typeof document !== "undefined" && data?.app_name) {
                    document.title = `${data.app_name} — Preserve Your Family Legacy Forever`;
                }
            })
            .catch((e) => console.debug("[Branding] fetch failed:", e?.message || e));
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <BrandingContext.Provider value={{ ...branding, refresh }}>
            {children}
        </BrandingContext.Provider>
    );
}

export function useBranding() {
    return useContext(BrandingContext);
}
